import React, { useState } from 'react';
import { CornerUpLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Backbutton({ to = '/' }) { // <-- prop for URL
  const [hoveredButton, setHoveredButton] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(to); // <-- go to the URL passed in prop
  };

  return (
    <button
      onClick={handleBack}
      onMouseEnter={() => setHoveredButton(4)}
      onMouseLeave={() => setHoveredButton(null)}
      className="group relative overflow-hidden"
    >
      <div className="hover:bg-gray-100 rounded px-2 py-1 transition-all duration-300">
        <div className="flex items-center space-x-2 text-gray-700">
          <CornerUpLeft className="w-5 h-5 transition-all duration-300" />
          <span>Back</span>
        </div>
      </div>
    </button>
  );
}
